module.exports = __webpack_public_path__ + "media/packs/images/flags/MA-7db066d58a46332f85aa10dc04e3db1a.png";